import React from 'react';
import {
  Text,
  DetailsList,
  SelectionMode,
  DetailsListLayoutMode,
  IDetailsListProps,
  DetailsRow,
  IColumn,
  useTheme,
} from '@fluentui/react';
import { Image, ImageFit } from '@fluentui/react/lib/Image';
import { IPeriodos } from './PlanillaDigitalView';

interface IPlanillaDigitalTimeoutDetailList {
  timeoutList: any[]; // todocambiar a interface
  color: string;
}

const PlanillaDigitalTimeoutDetailList = ({
  timeoutList: oficialesList,
  color,
}: IPlanillaDigitalTimeoutDetailList) => {
  const TimeoutColumns: IColumn[] = React.useMemo(() => {
    const ret = [
      {
        key: '1er T.O',
        fieldName: 'primer_to',
        name: '1er T.O',
        minWidth: 50,
        maxWidth: 150,
        // flexGrow: 1,
      },
      {
        key: '2do T.O',
        fieldName: 'segundo_to',
        name: '2do T.O',
        minWidth: 50,
        maxWidth: 200,
        // flexGrow: 1,
      },

      {
        key: '3er T.O',
        fieldName: 'tercer_to',
        name: '3er T.O',
        minWidth: 50,
        maxWidth: 250,
        // flexGrow: 1,
      },
    ];
    return ret;
  }, []);

  const getKey = (item: any, index?: number) => {
    return item.key;
  };

  const theme = useTheme();
  const _onRenderTimeoutRow: IDetailsListProps['onRenderRow'] = (props) => {
    if (props) {
      return (
        <div>
          <DetailsRow
            {...props}
            styles={{
              root: {
                backgroundColor: props.itemIndex % 2 === 0 ? theme.palette.neutralLight : 'transparent',
                selectors: {
                  ':hover': { backgroundColor: theme.palette.neutralQuaternaryAlt },
                },
              },
            }}
            className="planilla-detail-list"
          />
        </div>
      );
    }
    return null;
  };

  return (
    // <div style={{ border: '1px solid ' + color }}>
    <div>
      <DetailsList
        items={oficialesList}
        selectionMode={SelectionMode.none}
        columns={TimeoutColumns}
        setKey="none"
        styles={{ headerWrapper: { borderBottom: `3px solid ${color} !important` } }}
        // layoutMode={DetailsListLayoutMode.}
        isHeaderVisible={true}
        getKey={getKey}
        onRenderRow={_onRenderTimeoutRow}
        onShouldVirtualize={() => false}
      />
    </div>
  );
};

export default PlanillaDigitalTimeoutDetailList;
